module.exports = __webpack_public_path__ + "img/ma.e11a0692.svg";